import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { OneLoginApiService } from '../services/onelogin-api.service';

export const authGuard: CanActivateFn = async (_, state) => {
  const api = inject(OneLoginApiService);
  const router = inject(Router);
  const ok = await api.checkSession();
  if (ok) return true;
  router.navigate(['/login'], { queryParams: { returnUrl: state.url || '/' } });
  return false;
};
